module.exports = "/_next/static/images/dots-67c3b6f5118ecdcc3eeb2c813ba168f7.png";